import React, { useState } from "react";
import styles from "./Schedule.module.sass";
import cn from "classnames";
import Item from "./Item";
import Icon from "../Icon";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import Loader from "../Loader";

const Schedule = ({
	className,
	startDate,
	setStartDate,
	action = "Ok",
	onClick = () => {},
	title = "Schedule",
	isLoading = false,
	note = "Choose a day and time in the future you want your product to be published.",
	nobutton = false,
	nodate = false,
}) => {
	const [visibleDate, setVisibleDate] = useState(false);
	const [visibleTime, setVisibleTime] = useState(false);

	return (
		<div className={cn(styles.schedule, className)}>
			<div className={cn("title-red", styles.title)}>{title}</div>
			<div className={styles.note}>{note}</div>
			<div className={styles.list}>
				{!nodate && (
					<Item
						className={styles.item}
						category="Date"
						icon="calendar"
						value={startDate && format(startDate, "MMMM dd, yyyy")}
						visible={visibleDate}
						setVisible={setVisibleDate}
					>
						<div className={styles.date}>
							<DatePicker
								selected={startDate}
								onChange={(date) => setStartDate(date)}
								dateFormatCalendar={"MMMM yyyy"}
								inline
							/>
							<div className={styles.foot}>
								<button
									className={cn("button-small button-stroke", styles.button)}
									onClick={() => setVisibleDate(false)}
								>
									Close
								</button>
							</div>
						</div>
					</Item>
				)}
				<Item
					className={styles.item}
					category="Time"
					icon="clock"
					value={startDate && format(startDate, "h:mm aa")}
					visible={visibleTime}
					setVisible={setVisibleTime}
				>
					<div className={styles.time}>
						<div className={styles.top}>
							<div className={styles.subtitle}>
								{startDate && format(startDate, "h:mm aa")}
							</div>
							<button
								className={styles.close}
								onClick={() => setVisibleTime(false)}
							>
								<Icon name="close" size="20" />
							</button>
						</div>
						<DatePicker
							selected={startDate}
							onChange={(date) => setStartDate(date)}
							showTimeSelect
							showTimeSelectOnly
							timeIntervals={30}
							timeCaption={false}
							dateFormat="h:mm aa"
							inline
						/>
					</div>
				</Item>
			</div>
			{!nobutton && (
				<div className={styles.btns}>
					<button
						onClick={onClick}
						className={cn("button", styles.button, { disabled: isLoading })}
					>
						{isLoading && <Loader white />}
						{action}
					</button>
				</div>
			)}
		</div>
	);
};

export default Schedule;
